<button
  (click)="$event.preventDefault()"
  [class]="classList()"
  [disabled]="disabled()">
  <ng-content></ng-content>
  <ng-content select="mat-icon"></ng-content>
</button>
